import { useLazyQuery, useQuery } from "@apollo/client/react"; import { Autocomplete, Box, TextField, Grid, InputAdornment, CircularProgress } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';

import { getStringQueryCombosRI } from '../../../../data/graphQL/queries/ResumenIngreso/getAllCombosRI';
import { adaptCombosRIArray } from '../../../../adapters/resumenIngreso/combosRIAdapter';
import { useDebounce } from '../../../../hooks/useDebounce';
import { GET_INSUMOS } from '../../../../data/graphQL/queries/ResumenIngreso/getAllInsumos';
import SearchIcon from '@mui/icons-material/Search';
import { adaptInsumosArray } from '../../../../adapters/resumenIngreso/insumosAdapter';
import toast from 'react-hot-toast';

export const StepProgramaNPID2 = ({
  setDataSubmissionCallback,
  pantallas,
  updateFormData,
  fullFormDataRI,
  idDatosGeneralesRI
}) => {

  const [datosProgramaNPID, setDatosProgramaNPID] = useState(fullFormDataRI?.programaNPID2 ?? {});
  const [combosRI, setCombosRI] = useState();

  const [
    insumos,
    nombreInsumoSelected,
    filterStatus,
    insumosLoading,
    setFilterStatus,
    setNombreInsumoSelected] =
    useGetInsumos(datosProgramaNPID?.idInsumo, fullFormDataRI?.programaNPID2?.nombreInsumo, idDatosGeneralesRI);


  const inputCombos = inputsGroups.flatMap((inputgroup) => {
    return inputgroup.inputs.filter((input) => !!input.comboName);
  });

  useEffect(() => {
    setDatosProgramaNPID((prevData) => ({
      ...prevData,
      idPantallaRI: pantallas.find((p) => p.displayName.includes('NPID'))?.id
    }));
  }, [pantallas]);

  const handleSubmit = () => {
    if (!datosProgramaNPID?.bAPestandar && !datosProgramaNPID?.magistral) {
      return toast.error('Debe indicar BAP Estándar o BAP Magistral');
    }
    updateFormData('programaNPID2', datosProgramaNPID, parsedInputsGroup.flatMap((x) => x.inputs));
  };

  const { data: combosData } = useQuery(getStringQueryCombosRI(inputCombos));

  useEffect(() => {
    if (!combosData) return;

    setCombosRI(adaptCombosRIArray(combosData));
  }, [combosData]);

  const handleChange = (name, value) => {
    setDatosProgramaNPID((prevDatos) => ({
      ...prevDatos,
      [name]: value
    }));
  };

  const parsedInputsGroup = useMemo(() => {

    if (!combosRI) return inputsGroups;

    return inputsGroups.map((group) => ({
      ...group,
      inputs: group.inputs.map((input) => {
        if (!!input.comboName) {
          input.options = combosRI[input.name];
        }
        switch (input.name) {
          case 'idComboRIValorFAV':
            input.required = !datosProgramaNPID.idComboRIValorTipoCateter;
            break;
          case 'idComboRIValorTipoCateter':
            input.options = input.options.filter((o) => o.displayName !== 'En espera de colocación');
            input.required = !datosProgramaNPID.idComboRIValorFAV;
            break;
          case 'fechaColocacion':
          case 'idComboRIValorUbicacion':
          case 'idComboRIValorNroLumenes':
          case 'cateterNormal':
            input.required = !datosProgramaNPID.idComboRIValorFAV;
            break;

          case 'idInsumo':
            input.required = !!datosProgramaNPID.bAPestandar;
            input.disabled = !datosProgramaNPID.bAPestandar;
            if (input.disabled) {
              handleChange(input.name);
              setFilterStatus('');
            }
            break;
          case 'cantidadDiaria':
            input.required = !!datosProgramaNPID.bAPestandar;
            input.disabled = !datosProgramaNPID.bAPestandar;
            if (input.disabled) handleChange(input.name);
            break;
          case 'diasConexionSemana':
            input.required = !!datosProgramaNPID.bAPestandar;
            input.options = input.options.map((o) => ({ ...o, disabled: datosProgramaNPID.diasConexionSemanaMagistral?.includes(o.value) }));
            input.disabled = !datosProgramaNPID.bAPestandar;
            if (input.disabled) handleChange(input.name);
            break;
          case 'volumenMagistral':
            input.required = !!datosProgramaNPID.magistral;
            input.disabled = !datosProgramaNPID.magistral;
            if (input.disabled) handleChange(input.name);
            break;
          case 'diasConexionSemanaMagistral':
            input.required = !!datosProgramaNPID.magistral;
            input.options = input.options.map((o) => ({ ...o, disabled: datosProgramaNPID.diasConexionSemana?.includes(o.value) }));
            input.disabled = !datosProgramaNPID.magistral;
            if (input.disabled) handleChange(input.name);
            break;
          case 'idComboRIValorMotivoIndicacionMagistral':
            input.required = !!datosProgramaNPID.magistral;
            input.options = input.options.filter((o) => o.displayName.includes('Mixto'));
            input.disabled = !datosProgramaNPID.magistral;
            if (input.disabled) handleChange(input.name);
            break;

          default:
            break;
        }
        return input;
      })
    }));
  }, [
    combosRI,
    datosProgramaNPID.idComboRIValorFAV,
    datosProgramaNPID.idComboRIValorTipoCateter,
    datosProgramaNPID.bAPestandar,
    datosProgramaNPID.idInsumo,
    datosProgramaNPID.diasConexionSemanaMagistral,
    datosProgramaNPID.diasConexionSemana,
    datosProgramaNPID.magistral]
  );

  useEffect(() => {
    setDataSubmissionCallback(handleSubmit);
  }, [datosProgramaNPID, setDataSubmissionCallback, parsedInputsGroup]);


  useEffect(() => {
    if (!!datosProgramaNPID.idComboRIValorFAV)
      handleChange('idComboRIValorTipoCateter', null);
  }, [datosProgramaNPID.idComboRIValorFAV]);

  useEffect(() => {
    if (!!datosProgramaNPID.idComboRIValorTipoCateter)
      handleChange('idComboRIValorFAV', null);
  }, [datosProgramaNPID.idComboRIValorTipoCateter]);

  const handleSelectInsumo = (newValue) => {
    handleChange('idInsumo', newValue.id);
    setNombreInsumoSelected(newValue.label);
  };

  return (
    <div>
      {parsedInputsGroup.map((group) =>
        <div className='step-form-section-container' key={group.groupName}>
          <label className={`step-form-section-title`}>
            {group.groupName}
          </label>
          <Grid container>
            {group.inputs.map((input) => {
              return (
                <>
                  {input.name !== 'idInsumo' && <RenderInputByTypeMobile
                    key={`${group.groupName}-${input.name}`}
                    grided
                    handleChange={handleChange}
                    input={input}
                    value={datosProgramaNPID[input.name]} />
                  }
                  {input.name === 'idInsumo' && <Grid sx={{ marginTop: 2.5 }} size={{ xs: 12 }}>
                    <Autocomplete
                      options={insumos}
                      disabled={input.disabled}
                      key={datosProgramaNPID?.idInsumo}
                      value={nombreInsumoSelected}
                      disableClearable
                      noOptionsText={filterStatus ? 'No hay coincidencias' : 'Escriba para buscar'}
                      onChange={(_, newValue) => handleSelectInsumo(newValue)}
                      renderOption={(props, option) => {
                        return (
                          <Box {...props} key={option.id}>
                            {option?.label}
                          </Box>);

                      }}
                      renderInput={(params) => <TextField
                        {...params}
                        onChange={(e) => setFilterStatus(e.target.value)}
                        sx={{ '.MuiOutlinedInput-root': { paddingRight: '15px !important' } }}
                        label='¿Cuál?'
                        margin='none'
                        size='small'
                        inputProps={{
                          ...params.inputProps,
                          value: !!datosProgramaNPID.idInsumo || !!filterStatus ? params.inputProps.value : ''
                        }}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment:
                            <InputAdornment position='end'>
                              {insumosLoading ?
                                <CircularProgress color='inherit' size={20} /> :
                                <SearchIcon className='search-icon' />}
                            </InputAdornment>

                        }} />

                      } />

                  </Grid>}
                </>);

            })}
          </Grid>
        </div>
      )}
    </div>);

};

const useGetInsumos = (idInsumo, nombreInsumo, idDatosGeneralesRI) => {

  const [insumos, setInsumos] = useState([]);

  const [filterStatus, setFilterStatus] = useState('');
  const [nombreInsumoSelected, setNombreInsumoSelected] = useState('');
  const debouncedFilterValue = useDebounce(filterStatus, 1000);

  const [getInsumos, { loading: insumosLoading, data: insumosResults }] = useLazyQuery(GET_INSUMOS);

  useEffect(() => {
    if (!insumosResults) return;

    setInsumos(insumosResults);
  }, [insumosResults]);

  useEffect(() => {
    if (!nombreInsumo) return;
    setFilterStatus(nombreInsumo);
    setNombreInsumoSelected(nombreInsumo);
  }, [nombreInsumo]);

  useEffect(() => {
    if (!insumosLoading && !!debouncedFilterValue?.trim()) {
      getInsumos({
        variables: {
          idDatosGenerales: idDatosGeneralesRI,
          where: { descripcion: { contains: debouncedFilterValue } }
        }
      });
    }
  }, [debouncedFilterValue]);

  return [
    adaptInsumosArray(insumos) || [],
    nombreInsumoSelected,
    filterStatus,
    insumosLoading,
    setFilterStatus,
    setNombreInsumoSelected];


};

const inputsGroups = [
  {
    groupName: 'Accesos NPID',
    inputs: [
      {
        displayName: 'FAV',
        name: 'idComboRIValorFAV',
        comboName: 'FAV',
        type: 'select',
        required: false,
        disabled: false
      },
      {
        displayName: 'Catéter',
        name: 'idComboRIValorTipoCateter',
        comboName: 'Tipo de Catéter AP',
        type: 'select',
        required: false,
        disabled: false
      },
      {
        displayName: 'Fecha de colocación',
        name: 'fechaColocacion',
        disableFuture: true,
        type: 'date',
        required: false
      },
      {
        displayName: 'Ubicación de catéter',
        name: 'idComboRIValorUbicacion',
        comboName: 'Ubicación del catéter AP',
        type: 'select',
        required: false
      },
      {
        displayName: 'N° de lúmenes',
        name: 'idComboRIValorNroLumenes',
        comboName: 'N° de Luces',
        type: 'select',
        required: false
      },
      {
        displayName: '¿Sitio de inserción del catéter normal?',
        name: 'cateterNormal',
        type: 'boolean',
        required: false
      }]

  },
  {
    groupName: 'Indicaciones',
    inputs: [
      {
        displayName: 'BAP Estándar',
        name: 'bAPestandar',
        type: 'boolean',
        required: true
      },
      {
        displayName: '¿Cuál?',
        name: 'idInsumo',
        type: 'search',
        required: true
      },
      {
        displayName: 'Cantidad diaria',
        name: 'cantidadDiaria',
        type: 'int',
        min: 0,
        max: 2,
        required: false
      },
      {
        displayName: 'Conexiones por semana',
        name: 'diasConexionSemana',
        type: 'checkbox',
        options: [
          { value: 1, label: 'L' },
          { value: 2, label: 'M' },
          { value: 3, label: 'X' },
          { value: 4, label: 'J' },
          { value: 5, label: 'V' },
          { value: 6, label: 'S' },
          { value: 7, label: 'D' }],

        selectAllOption: true,
        required: true
      },
      {
        displayName: 'BAP Magistral',
        name: 'magistral',
        type: 'boolean',
        required: true
      },
      {
        displayName: 'Volumen',
        name: 'volumenMagistral',
        type: 'float',
        decimals: 2,
        min: 0,
        max: 4000,
        required: false
      },
      {
        displayName: 'Motivo de la indicación Magistral',
        name: 'idComboRIValorMotivoIndicacionMagistral',
        comboName: 'Motivo de la indicación Estandar AP',
        type: 'select',
        required: false
      },
      {
        displayName: 'Conexiones por semana',
        name: 'diasConexionSemanaMagistral',
        type: 'checkbox',
        options: [
          { value: 1, label: 'L' },
          { value: 2, label: 'M' },
          { value: 3, label: 'X' },
          { value: 4, label: 'J' },
          { value: 5, label: 'V' },
          { value: 6, label: 'S' },
          { value: 7, label: 'D' }],

        selectAllOption: true,
        required: false
      }]


  }];